<div class="modal-error">
  <div
    class="modal-close"
    role="button"
    tabindex="0"
    (click)="closeModal()"
    (keyup.enter)="closeModal()"
    (keyup.space)="closeModal()"
    aria-label="Close modal"
  >
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <use [attr.href]="icons[IconName.CLOSE]" />
    </svg>
  </div>
  <div class="modal-error__icon">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <use [attr.href]="icons[IconName.CLOSE]" />
    </svg>
  </div>
  <h2 class="modal-error__title">{{ 'errorModal.saveTitle' | translate }}</h2>
  <p class="modal-error__subtitle">{{ data.message | translate }}</p>
  <button class="modal-error__button btn-primary" (click)="closeModal()">
    {{ 'errorModal.closeButton' | translate }}
  </button>
</div>
